<template>
  <path
    d="M10 10.0202H15V21.0002H10V10.0202ZM17 21.0002H20C21.1 21.0002 22 20.1002 22 19.0002V10.0002H17V21.0002ZM20 3.00024H5C3.9 3.00024 3 3.90024 3 5.00024V8.00024H22V5.00024C22 3.90024 21.1 3.00024 20 3.00024ZM3 19.0002C3 20.1002 3.9 21.0002 5 21.0002H8V10.0002H3V19.0002Z"
  />
</template>
